import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../services/api';

export interface ResetLineMarkerResponse {
  lineColor: string;
  lineType: string;
  lineWeight: number;
  markerColor: string;
  markerType: string;
  markerSize: number;
}

export const resetLineMarker = createAsyncThunk(
  'resetLineMarker/fetchDefaultLineMarker',
  async (payload: { parameterName: string; resetType: string }) => {
    try {
      const apiEndpoint = `widgets/ResetWidgetLineMarkers`;

      const fullPayload = {
        dashboardName: 'esp-well-charts',
        widgetName: 'timeseriesChart',
        ...payload,
      };

      const response = await api.post(apiEndpoint, fullPayload, {
        headers: {
          'content-type': 'application/json',
        },
      });
      return response?.data ?? null;
    } catch (error) {
      console.error('Error fetching initial state:', error);
      return [];
    }
  },
);
